export default __webpack_public_path__ + "static/media/kitchen-notification.62d4da5a.mp3";